/**
 * Colors for visualizations
 * Source: "Colors for visualizations" design spec
 */

export const VISUALIZATION_COLORS = {
    pink: '#D5498E',
    blue: '#486FD9',
    green: '#66AB75',
    orange: '#FF8533',
    red: '#CB2027',
    yellow: '#F7D81E',
    purple: '#7851A9',
    lime: '#B5D334',
    mint: '#AAFFC3',
    cyan: '#42D4F4',
};

export const VISUALIZATION_LABEL_COLORS = {
    yellow: '#E0C000',
    lime: '#8FA531',
    mint: '#3FCF9A',
    cyan: '#1FC1E5',
};

/**
 * Heatmap color gradients
 * Each gradient has 4 stops with opacity: .55, .7, .85, 1
 * Light/dark variants are inverted versions of each other
 */
export const HEATMAP_GRADIENTS = {
    /** Pink - Visitor persona / Inspiration to dreaming phase */
    pink: {
        dark: [
            'rgba(115, 19, 110, .55)',
            'rgba(167, 32, 102, .7)',
            'rgba(213, 51, 84, .85)',
            'rgba(245, 99, 75, 1)',
        ],
        light: [
            'rgba(245, 99, 75, .55)',
            'rgba(213, 51, 84, .7)',
            'rgba(167, 32, 102, .85)',
            'rgba(115, 19, 110, 1)',
        ],
    },

    /** Blue - Planner persona / Planning to transaction phase */
    blue: {
        dark: [
            'rgba(48, 56, 127, .55)',
            'rgba(42, 97, 144, .7)',
            'rgba(43, 136, 154, .85)',
            'rgba(60, 180, 157, 1)',
        ],
        light: [
            'rgba(60, 180, 157, .55)',
            'rgba(43, 136, 154, .7)',
            'rgba(42, 97, 144, .85)',
            'rgba(48, 56, 127, 1)',
        ],
    },

    /** Green - Guest persona / Reservation complete to pre-stay phase, post-stay */
    green: {
        dark: [
            'rgba(32, 115, 123, .55)',
            'rgba(33, 152, 114, .7)',
            'rgba(67, 188, 87, .85)',
            'rgba(145, 214, 44, 1)',
        ],
        light: [
            'rgba(145, 214, 44, .55)',
            'rgba(67, 188, 87, .7)',
            'rgba(33, 152, 114, .85)',
            'rgba(32, 115, 123, 1)',
        ],
    },

    /** Orange - On-property guests / During-stay phase */
    orange: {
        dark: [
            'rgba(216, 78, 78, .55)',
            'rgba(239, 116, 57, .7)',
            'rgba(251, 162, 38, .85)',
            'rgba(247, 216, 30, 1)',
        ],
        light: [
            'rgba(247, 216, 30, .55)',
            'rgba(251, 162, 38, .7)',
            'rgba(239, 116, 57, .85)',
            'rgba(216, 78, 78, 1)',
        ],
    },

    /** Purple - Explorer persona / Early engagement phase, between dreaming and planning */
    purple: {
        dark: [
            'rgba(54, 35, 109, .55)',
            'rgba(91, 34, 107, .7)',
            'rgba(129, 33, 104, .85)',
            'rgba(167, 32, 102, 1)',
        ],
        light: [
            'rgba(167, 32, 102, .55)',
            'rgba(129, 33, 104, .7)',
            'rgba(91, 34, 107, .85)',
            'rgba(54, 35, 109, 1)',
        ],
    },

    /** Red - Other */
    red: {
        dark: [
            'rgba(139, 2, 73, .55)',
            'rgba(197, 0, 60, .7)',
            'rgba(232, 65, 51, .85)',
            'rgba(240, 131, 91, 1)',
        ],
        light: [
            'rgba(240, 131, 91, .55)',
            'rgba(232, 65, 51, .7)',
            'rgba(197, 0, 60, .85)',
            'rgba(139, 2, 73, 1)',
        ],
    },
};
